
	export const Welcome = {
		signButton: true,
		bars: true,
		links:[
	/* 	{
			id: "home",			
			title: "Home",
			to: "/"
		}, */
		{
			id: "swerlSignUp",
			title: "Sign Up",
			to: "/signup"
		},
		{
			id: "swerlSignIn",
			title: "Sign In",
			to: "/signin"
		},
		{
			id: "swerlAbout",
			title: "About Swerl",
			to: "/about"
		},
		{
			id: "swerlStore",
			title: "Store",
			to: "/store"
		}
		
		],
		
	}
	
	export const Access = { signButton: false, notifications: false, bars: false }
	
	
	
	
	


